const teams = [
  {
    name: 'Team Orange Mushroom',
    class: 'orange',
    isWinner: true,
    members: [
      {
        image: 'stoopzz',
        type: 'player',
        name: 'Stoopzz',
        description: 'My name is Stoopzz, and I am an MMORPG Content creator. Growing up, Maplestory was the first MMORPG I ever played. I am extremely excited for the opportunity to be able to participate in such an event!',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/Stoopzz_TV',
            label: 'TW',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/stoopzz',
            label: 'Twitch',
          },
        ],
      },
      {
        image: 'savix',
        type: 'player',
        name: 'Savix',
        description: 'Savix is a full-time content maker who is generally known for his gaming content in MMORPGs.',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/SavixIrL',
            label: 'TW',
          },
          {
            type: 'instagram',
            icon: 'fa-instagram',
            link: 'https://www.instagram.com/savixirl/',
            label: 'IG',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/savix',
            label: 'Twitch',
          },
        ],
      },
      {
        image: 'mimi',
        type: 'coach',
        name: 'Mimi',
        description:
          'Hi, I\'m Mimi. When I stream, I play MapleStory, and when I don\'t stream, I still play MapleStory.',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/NecromimiCos',
            label: 'TW',
          },
          {
            type: 'instagram',
            icon: 'fa-instagram',
            link: 'https://www.instagram.com/necromimicosplay/',
            label: 'IG',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/elizafaust',
            label: 'Twitch',
          },
        ],
      },
    ],
  },
  {
    name: 'Team Pink Bean',
    class: 'pink',
    isWinner: false,
    members: [
      {
        image: 'peterpark',
        type: 'player',
        name: 'Peterpark',
        description: 'Peter "peterpark" Park is a Los Angeles-based variety streamer for 100 Thieves. He currently hosts 100Thieves\' podcast series Boomer vs Zoomer with Kyedae.',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/peterparktv',
            label: 'TW',
          },
          {
            type: 'instagram',
            icon: 'fa-instagram',
            link: 'https://www.instagram.com/peterparktv/',
            label: 'IG',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/peterpark',
            label: 'Twitch',
          },
        ],
      },
      {
        image: 'blaustoise',
        type: 'player',
        name: 'Blaustoise',
        description: 'Nathan "Blaustoise" Blau is a content creator on Twitch and former dev at PlayStation, Riot, and InnerSloth, and he is known for his role as Mickey in the GTA NoPixel server.',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/blaustoise',
            label: 'TW',
          },
          {
            type: 'instagram',
            icon: 'fa-instagram',
            link: 'https://www.instagram.com/blaustoise',
            label: 'IG',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/blaustoise',
            label: 'Twitch',
          },
        ],
      },
      {
        image: 'daboki',
        type: 'coach',
        name: 'Daboki',
        description: 'Hi my name is David, I am a content creator on Youtube and Twitch. One of my favorite things to do is going to the mountains, and getting lost in my thoughts.',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/thedaboki',
            label: 'TW',
          },
          {
            type: 'youtube',
            icon: 'fa-youtube',
            link: 'https://www.youtube.com/thedaboki',
            label: 'YT',
          },
          {
            type: 'instagram',
            icon: 'fa-instagram',
            link: 'https://www.instagram.com/thedaboki',
            label: 'IG',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/daboki',
            label: 'Twitch',
          },
        ],
      },
    ],
  },
  {
    name: 'Team Green Slime',
    class: 'green',
    isWinner: false,
    members: [
      {
        image: 'zizaran',
        type: 'player',
        name: 'Zizaran',
        description: 'Path of Exile is my main game as a streamer. I started streaming in October 2015, and I\'m now a full time streamer. I\'m from Norway, but I moved to Belfast five years ago and studied Computer Science at Queens University!',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/Zizaran',
            label: 'TW',
          },
          {
            type: 'instagram',
            icon: 'fa-instagram',
            link: 'https://www.instagram.com/zizaran/',
            label: 'IG',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/zizaran',
            label: 'Twitch',
          },
        ],
      },
      {
        image: 'bajheera',
        type: 'player',
        name: 'Bajheera',
        description: 'One of the most inspirational leaders on Twitch, Bajheera takes his slogan of "Games And Gains" seriously. When he is not hitting the gym he is hitting WoW\'s PvP.',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/BajheeraWoW',
            label: 'TW',
          },
          {
            type: 'instagram',
            icon: 'fa-instagram',
            link: 'https://www.instagram.com/bajheerawow/',
            label: 'IG',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/bajheera',
            label: 'Twitch',
          },
        ],
      },
      {
        image: 'atobe112',
        type: 'coach',
        name: 'Atobe112',
        description: 'Hi I\'m Tree, Eh Canadian streamer who apparently gets called "Dad". I\'ve played MapleStory since open but you can find me now in NA Reboot.',
        socials: [
          {
            type: 'twitter',
            icon: 'fa-twitter',
            link: 'https://twitter.com/Atobe112',
            label: 'TW',
          },
          {
            type: 'youtube',
            icon: 'fa-youtube',
            link: 'https://www.youtube.com/c/atobe112',
            label: 'YT',
          },
          {
            type: 'discord',
            icon: 'fa-discord',
            link: 'https://discord.gg/tXyPXfSKpA',
            label: 'Discord',
          },
          {
            type: 'twitch',
            icon: 'fa-twitch',
            link: 'https://www.twitch.tv/atobe112',
            label: 'Twitch',
          },
        ],
      },
    ],
  }
]

export default teams
